import React, {Fragment, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {Modal,  Radio} from 'antd';
import {recordProxy} from '../../util';
import recommendImg from '../../asset/img/attest/recommend.png';
interface Props {
    authTypeOptShow: boolean;
    setAuthTypeOptShow: Function;
}
export default function AuthTypeOptModal(props: Props) {
    const history = useHistory();
    const {authTypeOptShow, setAuthTypeOptShow} = props;

    const [authType, setAuthType] = useState('0');
    // const [authTypeOptShow, setAuthTypeOptShow] = useState(props.authTypeOptShow);
    // useEffect(()=>{
    //     setAuthTypeOptShow(authTypeOptShow);
    // }, [authTypeOptShow]);
    // 合作伙伴协助认证和自主认证
    const authTypeSelect = () => {
        recordProxy('attest', 'authCourse-confirm', authType);
        setAuthTypeOptShow(false);
        if (authType === '0') {
            history.push('/companyGuide');
        } else {
            // 跳转百度云自主认证
            window.location.href = 'https://console.bce.baidu.com/spns/#/';
        }
    };
    return (
        <Fragment>
            <Modal
                title="系统评估您的企业为优质企业，可在线自主认证"
                cancelText="取消"
                okText="确定提交"
                className="page-attest-auth-type-modal"
                width={600}
                centered
                visible={authTypeOptShow}
                closable={false}
                onOk={authTypeSelect}
                onCancel={() => {
                    recordProxy('attest', 'click', 'authCourse-confirm-cancel');
                    setAuthTypeOptShow(false);
                }}
            >
                <div className={'auth-type-modal'}>
                    <div
                        className={'auth-type-modal-item' + (authType === '0' ? ' on' : '')}
                        onClick={() => setAuthType('0')}
                    >
                        <Radio
                            style={{'fontWeight': 600}}
                            name="authType"
                            checked={authType === '0'}
                        >
                            查看自主认证教程
                        </Radio>
                        <div className={'radio-text'}>
                            进行自主认证，需要您前往百度云平台提交资质并进行付费，建议您根据教程指引进行操作。
                        </div>
                        <img className={'radio-icon'}
                            width={70}
                            src={recommendImg}></img>
                    </div>
                    <div
                        className={'auth-type-modal-item' + (authType === '1' ? ' on' : '')}
                        onClick={() => setAuthType('1')}
                    >
                        <Radio
                            style={{'fontWeight': 600}}
                            name="authType"
                            checked={authType === '1'}
                        >
                            无需查看教程 直接开始认证
                        </Radio>
                        <div className={'radio-text'}>
                            选择后，您将跳转百度云认证平台
                        </div>
                    </div>
                </div>
            </Modal>
        </Fragment>
    );
}
